<template>
  <div class="item-card">
    <div class="card-title">优化设置</div>
    <div class="card-content">
      <ul class="modal-form">
        <el-form :model="formData" :rules="rules" ref="optimizeFormRef">
          <li class="form-item">
            <span class="form-label require">继承优质计划：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.auto_inherit_switch">
                <el-radio label="OFF">不开启</el-radio>
                <el-radio label="ON" :disabled="isUNION">开启</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="formData.auto_inherit_switch === 'ON'">
            <span class="form-label require">被继承计划归属：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.inherit_type">
                <el-radio label="INHERIT_FROM_ACCOUNT">当前账户</el-radio>
                <el-radio label="INHERIT_FROM_CUSTOMER">组织账户</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li
            class="form-item"
            v-show="
              formData.inherit_type === 'INHERIT_FROM_CUSTOMER' &&
              formData.auto_inherit_switch === 'ON'
            "
          >
            <span class="form-label require">广告账户：</span>
            <div class="form-value">
              <el-form-item prop="inherited_advertiser_id">
                <el-transfer
                  class="brand-transfer"
                  filterable
                  filter-placeholder="输入查询"
                  v-model="formData.inherited_advertiser_id"
                  :data="accountList"
                ></el-transfer>
              </el-form-item>
            </div>
          </li>
        </el-form>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { queryInheritedAdvertiserId } from "@/api/promotion.js";
export default {
  data() {
    return {
      formData: {
        auto_inherit_switch: "OFF",
        inherit_type: "INHERIT_FROM_ACCOUNT",
        inherited_advertiser_id: [],
      },
      accountList: [],
      isUNION: false,
      rules: {
        inherited_advertiser_id: [
          {
            validator: (rule, value, callback) => {
              let formData = this.formData;
              if (
                formData.auto_inherit_switch === "ON" &&
                formData.inherit_type === "INHERIT_FROM_CUSTOMER" &&
                formData.inherited_advertiser_id.length === 0
              ) {
                callback(new Error("请选择账户"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    searchAccountList() {
      queryInheritedAdvertiserId({
        advertiserId: this.adCount[0].advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          this.accountList = res.advertiseInfoList.map((item) => {
            item.key = item.advertiserId;
            item.label = item.advertiserName;
            return item;
          });
        }
      });
    },
    getListOption() {
      this.searchAccountList();
      this.renderData();
    },
    saveInStore() {
      let data = JSON.parse(JSON.stringify(this.formData));
      if (data.auto_inherit_switch === "OFF") {
        data.inherit_type = "INHERIT_FROM_ACCOUNT";
        data.inherited_advertiser_id = [];
      } else if (data.inherit_type === "INHERIT_FROM_ACCOUNT") {
        data.inherited_advertiser_id = [];
      }
      this.$store.commit("set_optimize", data);
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.optimizeFormRef.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    renderData() {
      let value = this.optimize;
      if (value) {
        this.formData.auto_inherit_switch = value.auto_inherit_switch;
        this.formData.inherit_type = value.inherit_type;
        this.formData.inherited_advertiser_id = value.inherited_advertiser_id;
      }
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.Promotion.adCount,
      optimize: (state) => state.Promotion.draft_adset.optimize,
      delivery_placement: (state) =>
        state.Promotion.draft_adset.delivery_placement,
    }),
  },
  watch: {
    delivery_placement(value) {
      if (value.delivery_range === "UNION") {
        //穿山甲时继承优质计划只能选择不限
        this.isUNION = true;
        this.formData.auto_inherit_switch = "OFF";
      } else {
        this.isUNION = false;
      }
    },
  },
};
</script>

<style  lang="less" scoped>
.item-card {
  background-color: #fff;
  padding: 24px;
  margin-bottom: 6px;
  .card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .card-content {
    margin-top: 20px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 20px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 126px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          // padding-top: 6px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(0, 0, 0, 0.65);
          }
          .brand-transfer {
            /deep/ .el-transfer-panel {
              width: 180px;
              height: 300px;
            }
          }
        }
      }
    }
  }
}
</style>